import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { SANS_STACK, TEXT_SECONDARY } from '../tokens';

const ViewAllButton = styled('button')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 2,
  border: 'none',
  background: 'none',
  padding: 0,
  cursor: 'pointer',
  fontFamily: SANS_STACK,
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '.06em',
  textTransform: 'uppercase',
  color: TEXT_SECONDARY,
  '&:hover': { color: theme.palette.primary.main },
}));

/**
 * The "All ›" link from a hero page's preview grid to the filtered item view.
 * Always offered while the grid has anything in it - the preview holding every
 * item doesn't make that view redundant, and what fits is a viewport accident.
 */
export default function ViewAllLink({ title, onClick }) {
  return (
    <ViewAllButton type="button" title={title} onClick={onClick}>
      All
      <ChevronRightIcon sx={{ fontSize: 14 }} />
    </ViewAllButton>
  );
}

ViewAllLink.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

ViewAllLink.defaultProps = {
  title: null,
  onClick: null,
};
